export const INTERCEPTOR_SKIP_ALL_HEADER = 'X-Skip-Interceptor';
